module.exports = __webpack_public_path__ + "static/media/nft-24.08299bd6.jpg";